import { DoqFaceSvgProps } from '../types';

const Algorithm = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1405_41493)">
      <g clipPath="url(#clip1_1405_41493)">
        {/* mask to hide the bottom outline of the circle */}
        <mask id="bottom-mask-algorithm">
          <circle cx="160" cy="160" r="160" fill="white" />
          <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
        </mask>
        <circle
          cx="160"
          cy="160"
          r="160"
          fill="#FCBF4C"
          mask="url(#bottom-mask-algorithm)"
        />
        <mask
          id="mask0_1405_41493"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
        </mask>
        <g mask="url(#mask0_1405_41493)">
          <rect x="80" y="120" width="160" height="200" fill="white" />
        </g>
        <path
          d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
          fill="#2974C4"
        />
        <path
          d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
          fill="#2974C4"
        />
        <path
          d="M178 112V112.002C178.511 112.025 178.981 112.293 179.262 112.724L184 120H136L140.738 112.724C141.019 112.293 141.489 112.025 142 112.002V112H178Z"
          fill="#141414"
        />
        <path
          d="M159.019 56.0001C160.123 56.0105 161.01 56.9143 161 58.0188L160.849 74.0188C160.839 75.1234 159.935 76.0103 158.83 75.9999C157.726 75.9895 156.839 75.0857 156.849 73.9812L157 57.9812C157.01 56.8766 157.914 55.9897 159.019 56.0001Z"
          fill="#CB3434"
        />
        <path
          d="M192.008 74.2636C192.967 73.7156 194.188 74.0488 194.736 75.0078C195.284 75.9669 194.951 77.1886 193.992 77.7366L179.992 85.7366C179.033 86.2846 177.811 85.9514 177.263 84.9924C176.715 84.0333 177.049 82.8116 178.008 82.2636L192.008 74.2636Z"
          fill="#CB3434"
        />
        <path
          d="M142 95.5402C142 86.9576 148.958 80 157.54 80H162.46C171.042 80 178 86.9576 178 95.5402V112H142V95.5402Z"
          fill="#CB3434"
        />
        <path
          d="M181 106C181 104.895 181.895 104 183 104H201C202.105 104 203 104.895 203 106C203 107.105 202.105 108 201 108H183C181.895 108 181 107.105 181 106Z"
          fill="#CB3434"
        />
        <path
          d="M119 104C117.895 104 117 104.895 117 106C117 107.105 117.895 108 119 108H137C138.105 108 139 107.105 139 106C139 104.895 138.105 104 137 104H119Z"
          fill="#CB3434"
        />
        <path
          d="M125.263 75.0078C125.811 74.0488 127.033 73.7156 127.992 74.2636L141.992 82.2636C142.951 82.8116 143.284 84.0333 142.736 84.9924C142.188 85.9514 140.967 86.2846 140.008 85.7366L126.008 77.7366C125.049 77.1886 124.715 75.9669 125.263 75.0078Z"
          fill="#CB3434"
        />
        <path
          d="M163 84C163 84 168.663 86.3826 171.113 91.3154C173.563 96.2483 172.832 104 172.832 104"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130 161.5C127.791 161.5 126 163.291 126 165.5V186.5C126 188.709 127.791 190.5 130 190.5H151C153.209 190.5 155 188.709 155 186.5V179.5H165V186.5C165 188.709 166.791 190.5 169 190.5H190C192.209 190.5 194 188.709 194 186.5V165.5C194 163.291 192.209 161.5 190 161.5H169C166.791 161.5 165 163.291 165 165.5V176.5H155V165.5C155 163.291 153.209 161.5 151 161.5H130ZM151 164.5H130C129.448 164.5 129 164.948 129 165.5V186.5C129 187.052 129.448 187.5 130 187.5H151C151.552 187.5 152 187.052 152 186.5V165.5C152 164.948 151.552 164.5 151 164.5ZM190 164.5H169C168.448 164.5 168 164.948 168 165.5V186.5C168 187.052 168.448 187.5 169 187.5H190C190.552 187.5 191 187.052 191 186.5V165.5C191 164.948 190.552 164.5 190 164.5Z"
          fill="#2974C4"
        />
        <path
          opacity="0.5"
          d="M88 240C88 235.582 91.5817 232 96 232H224C228.418 232 232 235.582 232 240V296C232 300.418 228.418 304 224 304H96C91.5817 304 88 300.418 88 296V240Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.06 247.927C112.06 252.368 108.46 255.968 104.02 255.968C104.008 255.968 103.996 255.968 103.985 255.968V263.896H136.618C136.691 263.703 136.827 263.529 137.024 263.406L147.478 256.914C147.487 256.908 147.496 256.903 147.505 256.897V247.871H136.771C136.219 247.871 135.771 247.424 135.771 246.871V240.935C135.771 240.383 136.219 239.935 136.771 239.935H158.878C159.43 239.935 159.878 240.383 159.878 240.935V246.871C159.878 247.424 159.43 247.871 158.878 247.871H148.505V256.897C148.515 256.903 148.524 256.908 148.533 256.914L158.986 263.406C159.616 263.798 159.616 264.714 158.986 265.105L148.533 271.598C148.524 271.604 148.515 271.609 148.505 271.615V275.702H167.945V272.926C167.945 272.373 168.392 271.926 168.945 271.926H183.244C183.796 271.926 184.244 272.373 184.244 272.926V275.702H195.997V263.946H192.94C192.387 263.946 191.94 263.498 191.94 262.946V256.911C191.94 256.359 192.387 255.911 192.94 255.911H195.997V247.92H187.885C185.742 247.92 184.006 246.183 184.006 244.041C184.006 241.899 185.742 240.162 187.885 240.162H204.233C206.376 240.162 208.112 241.899 208.112 244.041C208.112 246.183 206.376 247.92 204.233 247.92H196.997V255.911H199.276C199.828 255.911 200.276 256.359 200.276 256.911V259.428H216.038C216.287 257.479 217.952 255.972 219.97 255.972C222.159 255.972 223.934 257.747 223.934 259.936C223.934 262.126 222.159 263.9 219.97 263.9C217.947 263.9 216.278 262.385 216.036 260.428H200.276V262.946C200.276 263.498 199.828 263.946 199.276 263.946H196.997V287.951H204.997C207.216 287.951 209.015 289.75 209.015 291.969C209.015 294.187 207.216 295.986 204.997 295.986H187.994C185.775 295.986 183.976 294.187 183.976 291.969C183.976 289.75 185.775 287.951 187.994 287.951H195.997V276.702H184.244V278.96C184.244 279.512 183.796 279.96 183.244 279.96H168.945C168.392 279.96 167.945 279.512 167.945 278.96V276.702H148.505V288.111C150.448 288.367 151.947 290.029 151.947 292.041C151.947 294.23 150.172 296.005 147.983 296.005C145.794 296.005 144.019 294.23 144.019 292.041C144.019 290.014 145.541 288.342 147.505 288.106V276.702H115.248C115.16 276.811 115.046 276.904 114.906 276.973L108.782 279.981V288.136C110.644 288.461 112.06 290.086 112.06 292.041C112.06 294.23 110.285 296.005 108.096 296.005C105.907 296.005 104.132 294.23 104.132 292.041C104.132 289.958 105.739 288.25 107.782 288.089V279.98L101.658 276.973C100.912 276.607 100.912 275.544 101.658 275.178L107.782 272.171V264.896H102.985V255.902C99.033 255.394 95.9795 252.017 95.9795 247.927C95.9795 243.487 99.5792 239.887 104.02 239.887C108.46 239.887 112.06 243.487 112.06 247.927ZM115.394 275.702C115.308 275.486 115.146 275.296 114.906 275.178L108.782 272.171V264.896H136.782C136.849 264.976 136.929 265.046 137.024 265.105L147.478 271.598C147.487 271.604 147.496 271.609 147.505 271.615V275.702H115.394Z"
          fill="white"
        />
        <path
          d="M176 196H144C139.582 196 136 199.582 136 204C136 208.418 139.582 212 144 212H176C180.418 212 184 208.418 184 204C184 199.582 180.418 196 176 196Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1405_41493">
        <rect width="320" height="320" fill="white" />
      </clipPath>
      <clipPath id="clip1_1405_41493">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Algorithm };
